import { useAuthService } from '@/new_src/service/inbound/Auth/adapter';
import IndexedDBService from '@/new_src/service/outbound/IndexedDB/adapter';
import { useOktaService } from '@/new_src/service/outbound/Okta/adapter';

export const useAuthenticateApplication = () => {
  const OktaService = useOktaService();
  const AuthService = useAuthService();

  const handleSignOut = () => {
    OktaService.resetOktaSession();
    AuthService.signOutGlobalSession();
    IndexedDBService.clearAll();
  };

  return { handleSignOut };
};
